<main class="loyale-auth-page loyale-auth-page--centered">
  <div class="auth-brand"><img src="../../../assets/logo.svg" alt="Loyale"></div>
  <section class="auth-card" aria-label="Signing you in">
    <div class="auth-card__content auth-status">
      <span>Signing you in…</span>
    </div>
  </section>
</main>
